// Help Sheet Controller
// Controls the floating help bubble + bottom sheet overlay.
// Same pattern as chat_sheet_controller.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "sheet"]

  connect() {
    this.isOpen = false
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape)
    this.enableBodyScroll()
  }

  open() {
    this.isOpen = true
    this.backdropTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")
      this.sheetTarget.classList.remove("translate-y-full")
      this.sheetTarget.classList.add("translate-y-0")
    })
    this.disableBodyScroll()
  }

  close() {
    this.isOpen = false
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    this.sheetTarget.classList.remove("translate-y-0")
    this.sheetTarget.classList.add("translate-y-full")
    this.enableBodyScroll()
    setTimeout(() => {
      if (!this.isOpen) this.backdropTarget.classList.add("hidden")
    }, 300)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.isOpen) this.close()
  }

  disableBodyScroll() { document.body.style.overflow = "hidden" }
  enableBodyScroll()  { document.body.style.overflow = "" }
}
